import React, { FC }           from 'react';
import { Icon, SemanticICONS } from 'semantic-ui-react';
import classNames              from 'classnames';

import { FlexItem }        from '../../containers/FlexItem';
import { Flexbox }         from '../../containers/Flexbox';
import { FlexAlign, Size } from '../../../types/componentPropTypes';
import { ClassValue }      from 'classnames/types';


export interface DraggableRemovableItemProps {
    hasHandles?: boolean,
    hasRemove?: boolean,
    hasRemoveArea?: boolean,
    handlesContainerClasses?: ClassValue,
    removeContainerClasses?: ClassValue,
    contentContainerClasses?: ClassValue,
    align?: FlexAlign,
    marginBottom?: Size,
    removeIcon?: SemanticICONS,

    onClick?( e?: unknown ): void,

    [ additionalFlexboxProps: string ]: any
}

const defaultProps: DraggableRemovableItemProps = {
    align:                   FlexAlign.START,
    marginBottom:            Size.XS,
    handlesContainerClasses: [],
    removeContainerClasses:  [],
    contentContainerClasses: [],
    hasHandles:              true,
    hasRemove:               true,
    hasRemoveArea:           true,
    removeIcon:              'close',
    onClick:                 () => {},
}

const DraggableRemovableItem: FC<DraggableRemovableItemProps> = ( props ) => {

    let {
            children,
            hasHandles,
            hasHandlesArea,
            hasRemove,
            hasRemoveArea,
            onClick,
            align,
            marginBottom,
            handlesContainerClasses,
            removeContainerClasses,
            contentContainerClasses,
            removeIcon,
            ...rest
        } = props;

    return (
        <Flexbox align={ align } { ...rest } className={ props.marginBottom ? `margin-${ props.marginBottom }-bottom` : null } noWrap>

            { hasHandles && (
                <FlexItem noGrow className={ classNames( handlesContainerClasses ) }>
                    <div className={ 'padding-xs' }>
                        <Icon name={ 'bars' } color={ 'grey' }/>
                    </div>
                </FlexItem>
            ) }

            <FlexItem basis={ 50 } className={ classNames( contentContainerClasses ) }>

                { children }

            </FlexItem>

            { ( hasRemove || hasRemoveArea ) && (
                <FlexItem noGrow className={ classNames( removeContainerClasses ) }>
                    <div className={ 'padding-xs padding-sm-left' }>
                        { hasRemove
                          ? <Icon name={ removeIcon } onClick={ onClick } className={ 'cursor--pointer' }/>
                          : <span className={ 'opacity--0 cursor--default' }><Icon name={ removeIcon }/></span>
                        }
                    </div>
                </FlexItem>
            ) }

        </Flexbox>
    );
};

DraggableRemovableItem.defaultProps = defaultProps;

export { DraggableRemovableItem }
